/*eslint-disable */
const $ = window.jQuery = require('jquery');  
export default {
  name: 'dashboard-sidebar',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
		$(document).ready(function (argument) {
			$(".sidebar_collapsed_btn").click( function(){
        $('body').toggleClass('sidebar_collapsed')
			});
			// $(document).click(function(event) {
			//   //if you click on anything except the modal itself or the "open modal" link, close the modal
			//   if (!$(event.target).closest(".ab_btn, .light_bg_popup").length) {
      //   $(".lymphomap_main").removeClass("popup_actv");
			// 	$("body").find(".welcome_popup_wrp").removeClass("active");
      //   // $('.left_sidebar').removeClass('d-none')
			//   }
			// });
    });
  },
  methods: {

  }
}


